export const FETCH_CUSTOMER_REQUEST =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST'
export const FETCH_CUSTOMER_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST_SUCCESS'
export const FETCH_CUSTOMER_REQUEST_FAILURE =
  'integrations/shopify/FETCH_CUSTOMER_REQUEST_FAILURE'

export const FETCH_ORDERS_REQUEST = 'integrations/shopify/FETCH_ORDERS_REQUEST'
export const FETCH_ORDERS_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_ORDERS_REQUEST_SUCCESS'
export const FETCH_ORDERS_REQUEST_FAILURE =
  'integrations/shopify/FETCH_ORDERS_REQUEST_SUCCESS'

export const FETCH_CUSTOMER_EVENTS_REQUEST =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST'
export const FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS'
export const FETCH_CUSTOMER_EVENTS_REQUEST_FAILURE =
  'integrations/shopify/FETCH_CUSTOMER_EVENTS_REQUEST_FAILURE'

export const SEARCH_PRODUCTS_REQUEST =
  'integrations/shopify/SEARCH_PRODUCTS_REQUEST'
export const SEARCH_PRODUCTS_REQUEST_SUCCESS =
  'integrations/shopify/SEARCH_PRODUCTS_REQUEST_SUCCESS'
export const SEARCH_PRODUCTS_REQUEST_FAILURE =
  'integrations/shopify/SEARCH_PRODUCTS_REQUEST_FAILURE'

export const DRAFT_ORDER_CREATE_REQUEST =
  'integrations/shopify/DRAFT_ORDER_CREATE_REQUEST'
export const DRAFT_ORDER_CREATE_REQUEST_SUCCESS =
  'integrations/shopify/DRAFT_ORDER_CREATE_REQUEST_SUCCESS'
export const DRAFT_ORDER_CREATE_REQUEST_FAILURE =
  'integrations/shopify/DRAFT_ORDER_CREATE_REQUEST_FAILURE'

export const DRAFT_ORDER_CALCULATE_REQUEST =
  'integrations/shopify/DRAFT_ORDER_CALCULATE_REQUEST'
export const DRAFT_ORDER_CALCULATE_REQUEST_SUCCESS =
  'integrations/shopify/DRAFT_ORDER_CALCULATE_REQUEST_SUCCESS'
export const DRAFT_ORDER_CALCULATE_REQUEST_FAILURE =
  'integrations/shopify/DRAFT_ORDER_CALCULATE_REQUEST_FAILURE'

export const DRAFT_ORDER_UPDATE_REQUEST =
  'integrations/shopify/DRAFT_ORDER_UPDATE_REQUEST'
export const DRAFT_ORDER_UPDATE_REQUEST_SUCCESS =
  'integrations/shopify/DRAFT_ORDER_UPDATE_REQUEST_SUCCESS'
export const DRAFT_ORDER_UPDATE_REQUEST_FAILURE =
  'integrations/shopify/DRAFT_ORDER_UPDATE_REQUEST_FAILURE'

export const FETCH_DRAFT_ORDERS_REQUEST =
  'integrations/shopify/FETCH_DRAFT_ORDERS_REQUEST'
export const FETCH_DRAFT_ORDERS_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_DRAFT_ORDERS_REQUEST_SUCCESS'
export const FETCH_DRAFT_ORDERS_REQUEST_FAILURE =
  'integrations/shopify/FETCH_DRAFT_ORDERS_REQUEST_SUCCESS'

export const DRAFT_ORDER_COMPLETE_REQUEST =
  'integrations/shopify/DRAFT_ORDER_COMPLETE_REQUEST'
export const DRAFT_ORDER_COMPLETE_REQUEST_SUCCESS =
  'integrations/shopify/DRAFT_ORDER_COMPLETE_REQUEST_SUCCESS'
export const DRAFT_ORDER_COMPLETE_REQUEST_FAILURE =
  'integrations/shopify/DRAFT_ORDER_COMPLETE_REQUEST_FAILURE'

export const DRAFT_ORDER_DELETE_REQUEST =
  'integrations/shopify/DRAFT_ORDER_DELETE_REQUEST'
export const DRAFT_ORDER_DELETE_REQUEST_SUCCESS =
  'integrations/shopify/DRAFT_ORDER_DELETE_REQUEST_SUCCESS'
export const DRAFT_ORDER_DELETE_REQUEST_FAILURE =
  'integrations/shopify/DRAFT_ORDER_DELETE_REQUEST_FAILURE'

export const ORDER_CANCEL_REQUEST = 'integrations/shopify/ORDER_CANCEL_REQUEST'
export const ORDER_CANCEL_REQUEST_SUCCESS =
  'integrations/shopify/ORDER_CANCEL_REQUEST_SUCCESS'
export const ORDER_CANCEL_REQUEST_FAILURE =
  'integrations/shopify/ORDER_CANCEL_REQUEST_FAILURE'

export const INVOICE_PREVIEW_REQUEST =
  'integrations/shopify/INVOICE_PREVIEW_REQUEST'
export const INVOICE_PREVIEW_REQUEST_SUCCESS =
  'integrations/shopify/INVOICE_PREVIEW_REQUEST_SUCCESS'
export const INVOICE_PREVIEW_REQUEST_FAILURE =
  'integrations/shopify/INVOICE_PREVIEW_REQUEST_FAILURE'

export const INVOICE_SEND_REQUEST = 'integrations/shopify/INVOICE_SEND_REQUEST'
export const INVOICE_SEND_REQUEST_SUCCESS =
  'integrations/shopify/INVOICE_SEND_REQUEST_SUCCESS'
export const INVOICE_SEND_REQUEST_FAILURE =
  'integrations/shopify/INVOICE_SEND_REQUEST_FAILURE'

export const ORDER_REFUND_REQUEST = 'integrations/shopify/ORDER_REFUND_REQUEST'
export const ORDER_REFUND_REQUEST_SUCCESS =
  'integrations/shopify/ORDER_REFUND_REQUEST_SUCCESS'
export const ORDER_REFUND_REQUEST_FAILURE =
  'integrations/shopify/ORDER_REFUND_REQUEST_FAILURE'

export const FETCH_SHOP_INFO_REQUEST =
  'integrations/shopify/FETCH_SHOP_INFO_REQUEST'
export const FETCH_SHOP_INFO_REQUEST_SUCCESS =
  'integrations/shopify/FETCH_SHOP_INFO_REQUEST_SUCCESS'
export const FETCH_SHOP_INFO_REQUEST_FAILURE =
  'integrations/shopify/FETCH_SHOP_INFO_REQUEST_FAILURE'

export const SHOPIFY_EVENT_CREATE_REQUEST =
  'integrations/shopify/SHOPIFY_EVENT_CREATE_REQUEST'
export const SHOPIFY_EVENT_CREATE_REQUEST_SUCCESS =
  'integrations/shopify/SHOPIFY_EVENT_CREATE_REQUEST_SUCCESS'
export const SHOPIFY_EVENT_CREATE_REQUEST_FAILURE =
  'integrations/shopify/SHOPIFY_EVENT_CREATE_REQUEST_FAILURE'
